import React from "react"
import PropTypes from "prop-types"
import Modal from "../../../components/plei-modal"

const inputStyle = {
  textAlign: "center"  
}

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "center",
  marginTop: "10px",
}

const customPaymentContainerStyle = {
  display: "flex",
  justifyContent: "center",
}

const customPaymentButtonStyle = {
  width: "25%",
  height: "8rem",
}

const CustomPaymentButton = (props) =>
  <button onClick={props.onClick} className="shop-reservation__price-button custom" style={customPaymentButtonStyle}>Custom</button>

const PaymentInput = (props) =>
  <input id='custom_payment' style={inputStyle} onChange={props.onChange} />

class UncategorizedModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPaymentAmountInput: false,
      uncategorizedProductPrice: null,
    }
  }

  toggleShowPaymentAmountInput = () => {
    this.setState({ showPaymentAmountInput: !this.state.showPaymentAmountInput })
  }

  setUncategorizedProductPrice = (e) => {
    this.setState({ uncategorizedProductPrice: e.target.value })
  }

  submitProduct = () => {
    this.setState({ showPaymentAmountInput: false })
    this.props.onConfirm(this.state.uncategorizedProductPrice)
  }

  closeModal = () => {
    this.setState({ showPaymentAmountInput: false })
    this.props.onCancel()
  }

  render() {
    const { isOpen } = this.props
    if (!isOpen) return null

    return (
      <Modal
        show={true}
        onHide={this.closeModal}
        className="edit-product-modal"
        title="Custom Payment">
        <div style={customPaymentContainerStyle}>
          {this.state.showPaymentAmountInput
            ? <PaymentInput onChange={this.setUncategorizedProductPrice} />
            : <CustomPaymentButton onClick={this.toggleShowPaymentAmountInput} />}
        </div>
        <div style={buttonContainerStyle}>
          <button
            onClick={this.submitProduct}
            style={{width: "100px"}}
            className="btn btn-success">
              Add
          </button>
        </div>
      </Modal>
    )
  }
}

// ProductEditModal.propTypes = {
//   editProductId: PropTypes.number,
//   initialValues: PropTypes.object,
//   isOpen: PropTypes.bool,
//   onCancel: PropTypes.func.isRequired,
//   onSubmit: PropTypes.func.isRequired,
//   type: PropTypes.string
// }

export default UncategorizedModal